const GradingList = [
  {
    id: "1",
    label: "GIA",
    name: "GIA",
    selectedValue: false,
  },
  {
    id: "2",
    label: "CGL",
    name: "CGL",
    selectedValue: false,
  },
  {
    id: "3",
    label: "HRD",
    name: "HRD",
    selectedValue: false,
  },
  {
    id: "4",
    label: "AGT",
    name: "AGT",
    selectedValue: false,
  },
  {
    id: "5",
    label: "DGL",
    name: "DGL",
    selectedValue: false,
  },
  {
    id: "6",
    label: "IGI",
    name: "IGI",
    selectedValue: false,
  },
  {
    id: "7",
    label: "IGT",
    name: "IGT",
    selectedValue: false,
  },
  {
    id: "8",
    label: "NON-CERT",
    name: "Non-Cert",
    selectedValue: false,
  },
  {
    id: "9",
    label: "OTHERS",
    name: "Others",
    selectedValue: false,
  },
];

export default GradingList;